import { Box, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

interface Props {
  isLogin?: boolean;
  isPro?: boolean;
  isBrand?: boolean;
}

export function Footer({ isLogin, isPro, isBrand }: Props) {
  const getFooterOption = (link: string, text: string) => (
    <Link to={link}>
      <Typography
        className="text-center text-text-2"
        variant="body2"
      >
        {text}
      </Typography>
    </Link>
  );

  return (
    <Box className="flex justify-between gap-8 max-w-[450px]">
      {isLogin
        ? getFooterOption('/forgot-password', 'Forgot Password')
        : getFooterOption('/', 'Log in')}
      {!isBrand && getFooterOption('/register', 'Brand Registration')}
      {!isPro && getFooterOption('/experts/apply', 'Expert Registration')}
    </Box>
  );
}
